import _regeneratorRuntime from "/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "core-js/modules/es6.string.iterator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.string.starts-with";
import _createForOfIteratorHelper from "/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/@babel/runtime-corejs2/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import waves from '@/directive/waves'; // waves directive
import Pagination from '@/components/Pagination';
import { getPropList as _getPropList, getOptionList as _getOptionList, getOptionDetail as _getOptionDetail, saveOption, batchSaveOption, deleteOption, getOptionParentList as _getOptionParentList } from '@/api/datadictionary';
import { getNowString, getLocalTimestamp } from '@/utils';
import request from '@/utils/request';
export default {
  name: 'DataDictionary',
  components: {
    Pagination: Pagination
  },
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      propList: [],
      selectedProp: {},
      optionListData: [],
      listQuery: {
        page: 1,
        size: 10,
        language: this.$store.getters.language,
        param: {}
      },
      total: 0,
      listLoading: true,
      dialogVisible: false,
      optionEditForm: {},
      selectedOptionId: 0,
      parentOptionListData: [],
      batchOptionSaveForm: {},
      batchDialogVisible: false,
      withCode: 0,
      withParent: 0,
      loading: {},
      finishNum: 0
    };
  },
  computed: {
    optionTableColumns: function optionTableColumns() {
      var tdds = this.$store.getters.tableDataDictionary.tables;
      // console.log('currentTable()')
      if (tdds) {
        var currentTable = tdds.find(function (value) {
          return value.name === 'r_data_dictionary_option_list';
        });
        //console.log(currentTable)
        return currentTable.tableColumns;
      } else {
        return null;
      }
    }
  },
  watch: {
    finishNum: function finishNum(value) {
      //console.log(value)
      if (value == 2) {
        this.loading.close();
        this.finishNum = 0;
        //let randomNum = Math.round(Math.random()*10000)
        //this.$router.push('/?'+randomNum)
        this.$router.go(0);
      }
    }
  },
  created: function created() {
    this.getPropList();
  },
  methods: {
    getPropList: function getPropList() {
      var _this = this;
      this.listLoading = true;
      new Promise(function (resolve, reject) {
        _getPropList({
          language: _this.$store.getters.language
        }).then(function (response) {
          // console.log(response)
          if (response.data.code !== '0') {
            _this.$notify({
              title: _this.$t('notification.error.title'),
              message: response.data.message,
              type: 'error',
              duration: 3000
            });
          }
          _this.propList = response.data.data;
          //console.log(this.propList)
          if (_this.propList == null) {
            _this.propList = [];
          }
          if (_this.propList.length > 0) {
            _this.selectedProp = _this.propList[0];
            _this.getOptionList();
            _this.getOptionParentList();
          }
          _this.listLoading = false;
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    handleChooseProp: function handleChooseProp(item) {
      //console.log(item)
      if (item == null || item == '') {
        return;
      }
      this.selectedProp.value = item.value;
      this.selectedProp.label = item.label;
      this.getOptionList();
      this.getOptionParentList();
    },
    getOptionList: function getOptionList() {
      var _this2 = this;
      //console.log(this.selectedProp)
      if (this.selectedProp == null || Object.keys(this.selectedProp).length === 0 || this.selectedProp.value == null) {
        return;
      }
      this.listLoading = true;
      this.optionListData = [];
      new Promise(function (resolve, reject) {
        _this2.listQuery.param['propId'] = _this2.selectedProp.value;
        _getOptionList(_this2.listQuery).then(function (response) {
          // console.log(response)
          if (response.data.code !== '0') {
            _this2.$notify({
              title: _this2.$t('notification.error.title'),
              message: response.data.message,
              type: 'error',
              duration: 3000
            });
          }
          _this2.optionListData = response.data.data;
          _this2.total = response.data.total;
          //console.log(this.propList)
          if (_this2.optionListData == null) {
            _this2.optionListData = [];
          }
          _this2.listLoading = false;
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    getOptionParentList: function getOptionParentList() {
      var _this3 = this;
      //console.log(this.selectedProp)
      if (this.selectedProp == null || Object.keys(this.selectedProp).length === 0 || this.selectedProp.value == null) {
        return;
      }
      this.listLoading = true;
      this.optionListData = [];
      new Promise(function (resolve, reject) {
        _this3.listQuery.param['propId'] = _this3.selectedProp.value;
        _getOptionParentList(_this3.listQuery).then(function (response) {
          // console.log(response)
          if (response.data.code !== '0') {
            _this3.$notify({
              title: _this3.$t('notification.error.title'),
              message: response.data.message,
              type: 'error',
              duration: 3000
            });
          }
          _this3.parentOptionListData = response.data.data;
          //console.log(this.propList)
          if (_this3.parentOptionListData == null) {
            _this3.parentOptionListData = [];
          }
          if (_this3.parentOptionListData.length > 0) {
            _this3.withParent = 1;
          } else {
            _this3.withParent = 0;
          }
          _this3.listLoading = false;
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    handleResetOptionList: function handleResetOptionList() {
      this.listQuery = {
        page: 1,
        size: 10,
        language: this.$store.getters.language,
        param: {}
      };
      this.getOptionList();
    },
    handleAddOption: function handleAddOption() {
      this.selectedOptionId = 0;
      this.getOptionDetail();
      this.dialogVisible = true;
    },
    handleEditOption: function handleEditOption(row) {
      this.selectedOptionId = row.c_id;
      this.getOptionDetail();
      this.dialogVisible = true;
    },
    handleSaveOption: function handleSaveOption() {
      var _this4 = this;
      this.$confirm(this.$t('messageBox.confirm.body'), this.$t('messageBox.confirm.title'), {
        confirmButtonText: this.$t('button.confirm'),
        cancelButtonText: this.$t('button.cancel'),
        type: 'warning'
      }).then(function () {
        _this4.listLoading = true;
        _this4.optionEditForm.propId = _this4.selectedProp.value;
        _this4.optionEditForm.optionId = _this4.selectedOptionId;
        return new Promise(function (resolve, reject) {
          _this4.listLoading = true;
          saveOption(_this4.optionEditForm).then(function (response) {
            // console.log(response)
            if (response.data.code === '0') {
              _this4.$notify({
                title: _this4.$t('notification.success.title'),
                message: _this4.$t('notification.success.body'),
                type: 'success',
                duration: 3000
              });
              _this4.dialogVisible = false;
              _this4.getOptionList();
            } else {
              _this4.$notify({
                title: _this4.$t('notification.error.title'),
                message: response.data.message,
                type: 'error',
                duration: 3000
              });
            }
            _this4.listLoading = false;
            resolve(response);
          }).catch(function (error) {
            _this4.listLoading = false;
            reject(error);
          });
        });
      }).catch(function (error) {
        console.error(error);
        _this4.listLoading = false;
      });
      this.listLoading = false;
    },
    handleDeleteOption: function handleDeleteOption(row) {
      var _this5 = this;
      this.$confirm(this.$t('messageBox.confirm.body'), this.$t('messageBox.confirm.title'), {
        confirmButtonText: this.$t('button.confirm'),
        cancelButtonText: this.$t('button.cancel'),
        type: 'warning'
      }).then(function () {
        _this5.listLoading = true;
        return new Promise(function (resolve, reject) {
          deleteOption(row.c_id).then(function (response) {
            // console.log(response)
            if (response.data.code === '0') {
              _this5.$notify({
                title: _this5.$t('notification.success.title'),
                message: _this5.$t('notification.success.body'),
                type: 'success',
                duration: 3000
              });
              _this5.getOptionList();
            } else {
              _this5.$notify({
                title: _this5.$t('notification.error.title'),
                message: response.data.message,
                type: 'error',
                duration: 3000
              });
            }
            _this5.listLoading = false;
            resolve(response);
          }).catch(function (error) {
            _this5.listLoading = false;
            reject(error);
          });
        });
      }).catch(function (error) {
        console.error(error);
        _this5.listLoading = false;
      });
      this.listLoading = false;
    },
    closeDialog: function closeDialog() {
      this.dialogVisible = false;
    },
    getOptionDetail: function getOptionDetail() {
      var _this6 = this;
      this.listLoading = true;
      return new Promise(function (resolve, reject) {
        _getOptionDetail(_this6.selectedProp.value, _this6.selectedOptionId).then(function (response) {
          if (response.data.data != null) {
            _this6.optionEditForm = response.data.data;
          }
          if (response.data.code !== '0') {
            _this6.$notify({
              title: _this6.$t('notification.error.title'),
              message: response.data.message,
              type: 'error',
              duration: 3000
            });
          }
          _this6.listLoading = false;
          // console.log(response.data)
          resolve(response);
        }).catch(function (error) {
          console.log(error);
          _this6.listLoading = false;
          reject(error);
        });
      });
    },
    getLocalTime: function getLocalTime(timestamp) {
      return getLocalTimestamp(timestamp);
    },
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row,
        rowIndex = _ref.rowIndex;
      if (rowIndex === 0) {
        return 'warning-row';
      }
      return '';
    },
    handleDownload: function handleDownload() {
      var _this7 = this;
      // console.log('handleDownload')
      this.listLoading = true;
      var tHeader = [];
      var _iterator = _createForOfIteratorHelper(this.optionTableColumns.filter(function (n) {
          return n.visible;
        })),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var col = _step.value;
          tHeader.push(col.label);
        }
        // console.log(tHeader)
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.listQuery.param.header = tHeader;
      if (isNull(this.listQuery.extra)) {
        this.listQuery.extra = {};
      }
      this.listQuery.extra.tableColumns = this.optionTableColumns.filter(function (n) {
        return n.visible;
      });
      var fileName = this.selectedProp.label + '_' + getNowString() + '.xls';
      this.listQuery.extra.file_name = fileName;
      request({
        url: '/data-dictionary/download-excel',
        method: 'post',
        headers: {
          'accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        },
        data: this.listQuery,
        callBack: function callBack() {
          return true;
        },
        responseType: 'arraybuffer'
      }).then(function (response) {
        // console.log(response)
        var content = response.data;
        var blob = new Blob([content], {
          type: 'application/vnd.ms-excel;charset=utf-8'
        });
        //const fileName = fileName
        var __this = _this7;
        if (response.status === 200) {
          var headers = response.headers;
          if (headers['content-type'].startsWith('application/vnd')) {
            if ('download' in document.createElement('a')) {
              var elink = document.createElement('a');
              elink.download = fileName;
              elink.style.display = 'none';
              elink.href = URL.createObjectURL(blob);
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href); // 释放URL 对象
              document.body.removeChild(elink);
            } else {
              // IE10+下载
              navigator.msSaveBlob(blob, fileName);
            }
          } else {
            ab2string(response.data, function (data) {
              data = JSON.parse(data);
              console.log(data);
              if (data.code != '0') {
                if (data.code == '408') {
                  var __key = __this.$t(data.data.key);
                  var __value = data.data.value;
                  var __content = __key.format(__value);
                  __this.$confirm(__content, __this.$t('exportFile.confirm.title'), {
                    confirmButtonText: __this.$t('exportFile.confirm.confirmButton'),
                    cancelButtonText: __this.$t('exportFile.confirm.cancelButton'),
                    showCancelButton: true,
                    type: 'warning'
                  }).then(function () {}).catch(function () {
                    __this.$router.push('/sys/export-file/list');
                  });
                } else {
                  __this.$message({
                    message: data.message,
                    type: 'error'
                  });
                }
                return;
              } else {
                __this.$message({
                  message: data.message ? data.message : __this.$t('exportFile.exportSuccess'),
                  type: 'success'
                });
              }
            });
          }
        }
        _this7.listLoading = false;
      }).catch(function (error) {
        _this7.listLoading = false;
      });
    },
    handleImport: function handleImport() {
      this.batchDialogVisible = true;
    },
    closeBatchDialog: function closeBatchDialog() {
      this.batchDialogVisible = false;
    },
    handleBatchSaveOption: function handleBatchSaveOption() {
      var _this8 = this;
      this.$confirm(this.$t('messageBox.confirm.body'), this.$t('messageBox.confirm.title'), {
        confirmButtonText: this.$t('button.confirm'),
        cancelButtonText: this.$t('button.cancel'),
        type: 'warning'
      }).then(function () {
        _this8.listLoading = true;
        _this8.batchOptionSaveForm.propId = _this8.selectedProp.value;
        _this8.batchOptionSaveForm.withCode = _this8.withCode;
        _this8.batchOptionSaveForm.withParent = _this8.withParent;
        return new Promise(function (resolve, reject) {
          _this8.listLoading = true;
          batchSaveOption(_this8.batchOptionSaveForm).then(function (response) {
            // console.log(response)
            if (response.data.code === '0') {
              _this8.$notify({
                title: _this8.$t('notification.success.title'),
                message: _this8.$t('notification.success.body'),
                type: 'success',
                duration: 3000
              });
              _this8.batchDialogVisible = false;
              _this8.getOptionList();
            } else {
              _this8.$notify({
                title: _this8.$t('notification.error.title'),
                message: response.data.message,
                type: 'error',
                duration: 5000
              });
            }
            _this8.listLoading = false;
            resolve(response);
          }).catch(function (error) {
            _this8.listLoading = false;
            reject(error);
          });
        });
      }).catch(function (error) {
        console.error(error);
        _this8.listLoading = false;
      });
      this.listLoading = false;
    },
    handleRefreshDD: function handleRefreshDD() {
      this.loading = this.$loading({
        lock: true,
        text: this.$t('loading.default'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      var lang = this.$store.getters.language;
      this.finishNum = 0;
      this.refreshDataDictionary(lang);
    },
    refreshDataDictionary: function () {
      var _refreshDataDictionary = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(lang) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Promise.all([this.refreshTableDD(lang), this.refreshCodeDD(lang)]);
            case 2:
              return _context.abrupt("return", true);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function refreshDataDictionary(_x) {
        return _refreshDataDictionary.apply(this, arguments);
      }
      return refreshDataDictionary;
    }(),
    refreshTableDD: function refreshTableDD(lang) {
      var _this9 = this;
      this.$store.dispatch('tableDataDictionary/refreshTableDataDictionary', lang).then(function () {
        _this9.finishNum = _this9.finishNum + 1;
        console.log('Refresh tableDataDictionary success');
      }).catch(function () {
        _this9.finishNum = _this9.finishNum + 1;
        console.log('Refresh tableDataDictionary failed');
      });
    },
    refreshCodeDD: function refreshCodeDD(lang) {
      var _this10 = this;
      this.$store.dispatch('codeDataDictionary/refreshCodeDataDictionary', lang).then(function () {
        _this10.finishNum = _this10.finishNum + 1;
        console.log('Refresh codeDataDictionary success');
      }).catch(function () {
        _this10.finishNum = _this10.finishNum + 1;
        console.log('Refresh codeDataDictionary failed');
      });
    }
  }
};